export const get = (key: string, defaultValue: any) => {
  const stored = sessionStorage.getItem(key)
  if (!stored) {
    return defaultValue
  }

  try {
    return JSON.parse(stored)
  } catch (error) {
    console.error('Error parsing session storage item', error, key, stored)
    return defaultValue
  }
}

export const set = (key: string, value: any) => {
  sessionStorage.setItem(key, JSON.stringify(value))
}
